// extracted by css-extract-rspack-plugin
export default {"translucentWhite":"_1de32b8f"};